import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { EmailTaskModule } from 'src/app/features/email-task/email-task.module'
import { TranslateModule } from '@ngx-translate/core'
import { CommunicationBlockComponent } from './communication-block.component'

@NgModule({
  declarations: [CommunicationBlockComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmailTaskModule
  ],
  exports: [CommunicationBlockComponent]
})
export class CommunicationBlockModule {}
